import SPLIT_TAKINGS_DIAGRAM_GB from 'assets/images/stripe/commission-diagram.png';
import SPLIT_TAKINGS_DIAGRAM_US from 'assets/images/stripe/commission-diagram-us.png';
import GRAPHICS_TAB_PAYROLL_GB from 'assets/slickpay-splash/time-off/graphics-tab-three.svg';
import GRAPHICS_TAB_PAYROLL_US from 'assets/slickpay-splash/time-off/graphics-tab-three-us.png';

export const HR_TAB_PAYROLL_IMAGES = {
  US: GRAPHICS_TAB_PAYROLL_US,
  GB: GRAPHICS_TAB_PAYROLL_GB,
};

export const SPLIT_TAKINGS_IMAGES = {
  US: SPLIT_TAKINGS_DIAGRAM_US,
  GB: SPLIT_TAKINGS_DIAGRAM_GB,
};
